import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex h-100 align-items-center" }
const _hoisted_2 = { class: "content p-4 w-100 justify-content-center text-center" }
const _hoisted_3 = {
  key: 0,
  class: "d-inline-block user-role-autocomplete"
}
const _hoisted_4 = { class: "d-flex justify-content-end" }

import i18n from '@/lang/i18n';
import { ref, onMounted } from 'vue';
import SelectRoleChecker from '@/router/selectRoleChecker';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import UserRoleAutoComplete from '@/components/AutoCompletes/UserRoleAutoComplete.vue';
import Role from '@/types/SelfRole';
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'SelectRole',
  setup(__props) {

const router = useRouter()

const selected = ref<Role>();
const loading = ref(true);

onMounted(() => {
  getSelfRoles()
});

async function getSelfRoles() {
  const res = await SelectRoleChecker.getSelfRoles();
  const count = await SelectRoleChecker.getRoleCount();
  if (count == 1) {
    SelectRoleChecker.selectRole(res[0])
    await AuthorityCacheApi.reflesh()
    redirectRoot()
  } else {
    loading.value = false
  }
}

async function handleSelectRole() {
  if (selected.value) {
    SelectRoleChecker.selectRole(selected.value)
    await AuthorityCacheApi.reflesh()
    redirectRoot()
  }
}

function redirectRoot() {
  router.replace('/')
}


return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(UserRoleAutoComplete, {
              class: "w-100",
              modelValue: selected.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selected).value = $event)),
              initialRoleId: selected.value?.id,
              clearable: true
            }, null, 8, ["modelValue", "initialRoleId"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_btn, {
                class: "mr-5 ma-2 exec-btn",
                onClick: handleSelectRole,
                disabled: !selected.value,
                style: _normalizeStyle({
              backgroundColor: loading.value ? '#B3B8BB' : '',
            })
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.selectBtn')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "style"])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})